module.exports = __webpack_public_path__ + "img/icon_close_background.671acdda.png";